import React, { useEffect, useState } from 'react'
import { Season, SeasonProperties } from 'models'
import { BuildForm, BuildFormArgs } from 'features/build-form'
import * as modelProps from 'models/season/season-property-definitions';
import utils from 'features/season/season-util'
import validations from 'features/season/season-validation'

export interface SeasonProps {
    BuildList?: (page: any, name: SeasonProperties, form: Season) => JSX.Element[]
    page?: any
    title?: any
    form?: Season
    onUpdate?: (form: Season, valid: boolean, dirty: boolean) => void
    clear?: (callback: () => void) => void
    context?: any
}
export default function SeasonForm(props: SeasonProps) {
    let [form, setForm] = useState({} as Season)
    let [dirty, setDirty] = useState({} as any)
    let [hasPosted, setHasPosted] = useState({} as any)
    let [changed, setChanged] = useState(false)
    if (props.clear) {
        props.clear(() => {
            if (changed) {
                setForm({} as Season)
                setDirty({})
                setHasPosted({})
                setChanged(false)
            }
        })
    }

    useEffect(() => {
        if (changed) {
            setForm({} as Season)
            setDirty({})
            setHasPosted({})
            setChanged(false)
        }
    }, [props?.context?.id])

    let temp: any = { ...(props.form || {}), ...(form || {}) }
    let args: BuildFormArgs<Season, SeasonProperties> | any = {
        ...utils,
        form: temp,
        context: props.context,
        utilValidations: validations,
        page: props.page,
        GetPageProperties: () => {
            let properties = utils.GetPageProperties();
            return properties.filter(x => ![
                modelProps.SeasonProperties.Id,
                modelProps.SeasonProperties.Deleted,
                modelProps.SeasonProperties.Version,
                modelProps.SeasonProperties.Created,
                modelProps.SeasonProperties.Updated,
                modelProps.SeasonProperties.Owner,
                modelProps.SeasonProperties.MediaStatus,
                modelProps.SeasonProperties.Media,
                modelProps.SeasonProperties.SeriesId,
            ].includes(x.name))
        },
        BuildList: (page, name: SeasonProperties, form: Season) => {
            if (props && props.BuildList) {
                return props.BuildList(page, name, form)
            }
            return []
        },
        setForm: (
            form: Season,
            property: SeasonProperties,
            formValid: boolean,
            updates?: any,
        ) => {
            let newDirty = { ...dirty }
            if (property) {
                newDirty = { ...dirty, [property]: true }
            }
            if (updates) {
                Object.keys(updates).forEach((property) => {
                    newDirty = { ...newDirty, ...dirty, [property]: true }
                })
            }
            setDirty(newDirty)
            let updatedForm: any = {}
            for (let i in newDirty) {
                updatedForm[i] = (form as any)[i]
            }
            setChanged(true)
            setForm(updatedForm)
            if (props.onUpdate) {
                props.onUpdate(
                    { ...(props.form || {}), ...updatedForm },
                    formValid,
                    newDirty,
                )
            }
        },
        isDirty: (property: SeasonProperties) => {
            return dirty[property]
        },
        hasPosted: () => hasPosted,
    }
    return (
        <React.Fragment>{BuildForm<Season, SeasonProperties>(args)}</React.Fragment>
    )
}
